// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { Link } from "@tanstack/react-router";
import { Store } from "lucide-react";
import { cn } from "@/lib/utils";

interface StoreLinkProps {
  storeName: string;
  legibleName?: string;
  className?: string;
  showIcon?: boolean;
}

/**
 * Linked store reference: leading store icon + legible name, pointing to `/stores/$storeName`.
 * Drop-in for the per-cell `<Link>` we used to render in data tables.
 */
export function StoreLink({ storeName, legibleName, className, showIcon = true }: StoreLinkProps) {
  return (
    <Link
      to="/stores/$storeName"
      params={{ storeName }}
      className={cn("whitespace-nowrap text-primary hover:underline", className)}
    >
      {showIcon && <Store className="mr-1.5 inline-block size-3.5 align-[-0.15em]" aria-hidden="true" />}
      <span>{legibleName || storeName}</span>
    </Link>
  );
}
